import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  Drawer,
  Button,
  Radio,
  Space,
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Upload,
  InputNumber,
  Checkbox,
  message,
} from "antd";
import _ from "lodash";
import moment from "moment";
import axios from "axios";
import { UploadOutlined, StarOutlined } from "@ant-design/icons";
import config from "../../../config";
import { professionalAction } from "../../../_actions/professional.actions";
import Compressor from "compressorjs";
import { authHeader } from "../../../_helpers";
import { LanguageContext } from "../../../context/LanguageContext";
import { professionalService } from "../../../_services";
import { AccusedImageCropModal } from "./AccusedImageCropModal";

const { Option } = Select;
const { forwardRef, useRef, useImperativeHandle } = React;
export const NoticeForm = forwardRef((props, ref) => {
  const baseUrl = config.apiGateway.baseUrl;
  const [form] = Form.useForm();
  const [progress, setProgress] = useState(0);
  // Image and PDF file lists are managed separately
  const [imageFileList, setImageFileList] = useState([]);
  const [pdfFileList, setPdfFileList] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [selectDistricts, setSelectDistricts] = useState();
  const [cropModalVisible, setCropModalVisible] = useState(false);
  const [cropImageSrc, setCropImageSrc] = useState("");
  const [cropOriginalFile, setCropOriginalFile] = useState(null);
  const cropResolveRef = useRef(null);
  const { t } = useContext(LanguageContext);
  const [inputField, setInputField] = useState({
    notice_date: "",
  });
  const user = JSON.parse(localStorage.getItem("user"));
  const [type, setType] = useState();
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user) {
      professionalService
        .getDistrict(user.cityId)
        .then((res) => {
          setDistricts(res?.pc_districts || []);
        })
        .catch((err) => {
          console.log("District API Error:", err);
        });
    }
  }, []);

  const getDistrictName = () => {
    if (districts && districts.length) {
      const found = districts.find(
        (o) => String(o.id) === String(user.districtId),
      );
      if (found) {
        setSelectDistricts(found.DistrictName);
        form.setFieldsValue({
          action_taken_police_station: found.DistrictName,
        });
      }
    }
  };
  useEffect(() => {
    if (props.role === "2" && districts && districts.length && user.districtId) {
      getDistrictName();
    }
  }, [user.role, districts, user.districtId]);

  useEffect(
    (res) => {
      if (
        props.editData &&
        props.editData.length &&
        props.editData[0].noticeInfo &&
        props.editData[0].noticeInfo.length
      ) {
        let ob = {
          ...props.editData[0].noticeInfo[0],
        };
        form.setFieldsValue({
          ...ob,
          notice_date: props.editData[0].noticeInfo[0]
            ? moment(props.editData[0]?.noticeInfo[0]?.notice_date)
            : null,
        });
        setType(props.editData[0]?.noticeInfo[0]?.type);

        // IMAGE UPDATE ACCUSED IMAGE
        let accusedImageTemp =
          props.editData[0].noticeInfo[0].aaropi_photo &&
          props.editData[0].noticeInfo[0].aaropi_photo.length
            ? props.editData[0].noticeInfo[0].aaropi_photo.split(",")
            : [];
        let accusedImage =
          accusedImageTemp &&
          accusedImageTemp.length &&
          accusedImageTemp.map((item, index) => {
            return {
              uid: index,
              name: item,
              status: "done",
              url: process.env.REACT_APP_PROFILE_IMAGE_BUCKET_URL + item,
            };
          });
        setImageFileList(accusedImage && accusedImage ? accusedImage : []);

        // If backend provides a separate field for PDF name, map it similarly here.
        // Example: props.editData[0].noticeInfo[0].document
        if (
          props.editData[0].noticeInfo[0].photo &&
          props.editData[0].noticeInfo[0].photo.length
        ) {
          const pdfItems = props.editData[0].noticeInfo[0].photo
            .split(",")
            .map((item, index) => ({
              uid: `pdf-${index}`,
              name: item,
              status: "done",
              url: process.env.REACT_APP_PROFILE_IMAGE_BUCKET_URL + item,
            }));
          setPdfFileList(pdfItems);
        } else {
          setPdfFileList([]);
        }
      } else {
        form.resetFields();
        setImageFileList([]);
        setPdfFileList([]);
      }
    },
    [props.editData],
  );
  const disableFutureDates = (current) => {
    return current && current > moment().endOf("day");
  };

  const onFinish = async (values) => {
    try {
      // Extract uploaded filenames
      const accusedImage = imageFileList && imageFileList[0]?.name;
      const uploadedPdf = pdfFileList && pdfFileList[0]?.name;

      let obj = {
        ...values,
        gunhaId: props.editData && props.editData[0].id,
        notice_date: values?.notice_date && moment(values?.notice_date),
        photo: uploadedPdf || undefined,
        aaropi_photo: accusedImage || undefined,
        name: values.name,
        mobile_no: values.mobile_no,
        aaropi_number: values.aaropi_number,
        aaropi_aadhar_number: values.aaropi_aadhar_number,
        aaropi_address: values.aaropi_address,
        aaropi_pincode: values.aaropi_pincode,
        type: type,
      };

      if (
        props?.editData?.length > 0 &&
        props?.editData[0]?.noticeInfo?.length > 0
      ) {
        await props.onNoticeInfromationFormUpdate(
          obj,
          props?.editData[0]?.noticeInfo[0],
        );
      } else {
        await props.onNoticeFormFiniesh(obj);
      }
    } catch (error) {}
  };

  useImperativeHandle(ref, () => ({
    onFinish() {
      form.submit();
    },
  }));

  // Image validation (optional basic type check; compression is handled later)
  // function beforeUploadImage(file) {
  //   if (!file) return false;
  //   const isImage = ["image/jpeg", "image/png", "image/jpg"].includes(
  //     file.type
  //   );
  //   if (!isImage) {
  //     message.error("You can only upload JPG/PNG files!");
  //     return Upload.LIST_IGNORE;
  //   }
  //   return true;
  // }

  function beforeUploadImage(file) {
    return new Promise((resolve, reject) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";

      if (!isJpgOrPng) {
        message.error("You can only upload JPG/PNG file!");
        return reject(false);
      }

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("Image size must be less than 2MB!");
        return reject(false);
      }

      // 🔥 Magic number validation
      const reader = new FileReader();
      reader.onloadend = function (e) {
        const arr = new Uint8Array(e.target.result).subarray(0, 4);
        let header = "";
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16);
        }

        const isJPEG = header.startsWith("ffd8ff");
        const isPNG = header === "89504e47";

        if (!isJPEG && !isPNG) {
          message.error("Invalid image file! Possible malicious file.");
          return reject(false);
        }

        resolve(true);
      };

      reader.readAsArrayBuffer(file.slice(0, 4));
    });
  }

  const closeCropModal = () => {
    if (cropImageSrc) {
      URL.revokeObjectURL(cropImageSrc);
    }
    setCropModalVisible(false);
    setCropImageSrc("");
    setCropOriginalFile(null);
  };

  const finishCrop = (nextFile) => {
    cropResolveRef.current?.resolve(nextFile);
    cropResolveRef.current = null;
    closeCropModal();
  };

  const cancelCrop = () => {
    cropResolveRef.current?.reject(Upload.LIST_IGNORE);
    cropResolveRef.current = null;
    closeCropModal();
  };

  function beforeUploadAccusedPhoto(file) {
    return beforeUploadImage(file).then(() => {
      return new Promise((resolve, reject) => {
        cropResolveRef.current = { resolve, reject };
        setCropOriginalFile(file);
        setCropImageSrc(URL.createObjectURL(file));
        setCropModalVisible(true);
      });
    });
  }

  // PDF validation
  // function beforeUploadPdf(file) {
  //   if (!file) return false;

  //   const isPdf = file.type === "application/pdf";
  //   if (!isPdf) {
  //     message.error("You can only upload PDF files!");
  //     return Upload.LIST_IGNORE;
  //   }

  //   const isLt2M = file.size / 1024 / 1024 < 2;
  //   if (!isLt2M) {
  //     message.error("File size must be smaller than 2MB!");
  //     return Upload.LIST_IGNORE;
  //   }

  //   return true;
  // }

  function beforeUploadPdf(file) {
    return new Promise((resolve, reject) => {
      const isPdfType = file.type === "application/pdf";

      if (!isPdfType) {
        message.error("Please upload only PDF file!");
        return reject(false);
      }

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("PDF size larger than 2MB!");
        return reject(false);
      }

      // ✅ Correct Magic number validation for PDF
      const reader = new FileReader();
      reader.onloadend = function (e) {
        const arr = new Uint8Array(e.target.result).subarray(0, 4);
        let header = "";

        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16);
        }

        const isPDF = header === "25504446";

        if (!isPDF) {
          message.error("Invalid PDF file! Possible malicious file.");
          return reject(false);
        }

        resolve(true);
      };

      reader.readAsArrayBuffer(file.slice(0, 4));
    });
  }

  const handleRemoveImage = (file) => {
    const nextList = (imageFileList || []).filter((f) => f.uid !== file.uid);
    setImageFileList(nextList);
  };

  const handleRemovePdf = (file) => {
    const nextList = (pdfFileList || []).filter((f) => f.uid !== file.uid);
    setPdfFileList(nextList);
  };

  const uploadPdf = async (options) => {
    const { onSuccess, onError, file, onProgress } = options;
    const fmData = new FormData();
    fmData.append("document", file, file.name);

    try {
      const res = await axios.post(
        baseUrl + "/document/documentUpload",
        fmData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (event) => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            onProgress({ percent });
          },
        },
      );

      if (res.data && res.data.error) {
        onError(res.data.error);
      } else {
        setPdfFileList([
          {
            uid: String(Date.now()),
            name: res.data.imageName,
            status: "done",
            url: process.env.REACT_APP_PROFILE_IMAGE_BUCKET_URL,
          },
        ]);
        onSuccess("Ok");
      }
    } catch (err) {
      onError(err);
    }
  };

  const uploadImage = (options) => {
    const { onSuccess, onError, file, onProgress } = options;
    console.log("options", options);

    // Get actual File/Blob object
    const rawFile = file.originFileObj || file;

    new Compressor(rawFile, {
      quality: 0.2,
      async success(result) {
        const fmData = new FormData();
        setProgress(0);

        const config = {
          headers: {
            accept: "application/json",
            "Accept-Language": "en-US,en;q=0.8",
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (event) => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            setProgress(percent);
            if (percent === 100) {
              setTimeout(() => setProgress(0), 1000);
            }
            onProgress({ percent: (event.loaded / event.total) * 100 });
          },
        };

        const newFileName = "pc_" + result.name;
        fmData.append("profileImage", result, newFileName);

        try {
          const res = await axios.post(
            baseUrl + "/imageupload/profile-img-upload",
            fmData,
            config,
          );
          if (res.data && res.data.error) {
            onError(res.data.error);
          } else {
            setImageFileList([
              ...(imageFileList || []),
              {
                uid: String(Date.now()),
                name: res.data.imageName,
                status: "done",
                url: process.env.REACT_APP_PROFILE_IMAGE_BUCKET_URL,
              },
            ]);
            onSuccess("Ok");
          }
        } catch (err) {
          onError(err);
        }
      },
      error(err) {
        console.error("Compressor error:", err.message);
        onError(err);
      },
    });
  };

  const [startDate, setStartDate] = useState(null);

  useEffect(() => {
    if (props?.editData[0]?.noticeInfo[0]?.notice_date) {
      setStartDate(props.editData[0]?.noticeInfo[0]?.notice_date);
    }
  }, [props?.editData]);

  const [defaultDate, setDefaultDate] = useState(null);
  const onYearChange = (date) => {
    if (date) {
      const arrestDate = moment(date).startOf("day"); // ✅ only date part
      const nextDay = moment(arrestDate).add(1, "days");
      setStartDate(arrestDate);
      // form.setFieldsValue({
      //   notice_date: nextDay,
      // });
    } else {
      setStartDate(null);
      // form.setFieldsValue({
      //   notice_date: null,
      // });
    }
  };

  const disablePreviousDates = (current) => {
    if (!startDate) {
      return true;
    }
    return current && current < moment(startDate).add(1, "days").startOf("day");
  };
  const disableDateOfBithDates = (current) => {
    return current && current > moment().endOf("day");
  };
  function disabledDate(current) {
    if (!startDate) return true;
    return current && !current.isSame(moment(startDate), "year");
  }

  return (
    <div>
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Row gutter={18}>
          <Col span={12}>
            <Form.Item
              name="type"
              label="नोटीस चा प्रकार निवडा"
              rules={[
                {
                  required: true,
                  message: "कृपया नोटीस चा प्रकार निवडा",
                },
              ]}
            >
              <Select
                placeholder="निवडा"
                optionFilterProp="children"
                value={type}
                onChange={(val) => {
                  setType(val);
                  form.setFieldsValue({ type: val }); // <-- sync with Form
                }}
                allowClear
              >
                <Option value="BNS_35_3">
                  भारतीय नागरिक सुरक्षा संहिता २०२३ चे कलम ३५(३) प्रमाणे
                </Option>
                <Option value="CrPC_41A">
                  फौजदारी प्रक्रिया संहिता ४१(अ) प्रमाणे
                </Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={18}>
          <Col span={6}>
            <Form.Item
              name="name"
              label={t("officer_name")}
              rules={[{ required: true, message: "Please add name" }]}
            >
              <Input
                onKeyPress={(e) => {
                  if (!/[A-Za-z\u0900-\u097F\s]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                placeholder="Please enter user name"
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="mobile_no"
              label={t("officer_mobile")}
              rules={[
                {
                  required: true,
                  message: "Please enter a valid 10-digit mobile number",
                },
                {
                  pattern: /^[0-9]{10}$/,
                  message: "Please enter a valid 10-digit mobile number",
                },
              ]}
            >
              <Input
                maxLength={10}
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onPaste={(event) => {
                  event.preventDefault();
                }}
                placeholder="Please enter user mobile.no"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={18}>
          <Col span={6}>
            <Form.Item
              name="aaropi_number"
              label="आरोपीचा मोबईल नंबर"
              rules={[
                {
                  // required: true,
                  message: "Please enter a valid 10-digit mobile number",
                },
                {
                  pattern: /^[0-9]{10}$/,
                  message: "Please enter a valid 10-digit mobile number",
                },
              ]}
            >
              <Input
                maxLength={10}
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onPaste={(event) => {
                  event.preventDefault();
                }}
                placeholder="आरोपीचा मोबईल नंबर"
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="aaropi_aadhar_number"
              label={t("accused_aadhaar_number")}
              rules={[
                {
                  pattern: /^[0-9]{12}$/,
                  message: "Aadhaar number must be exactly 12 digits",
                },
              ]}
            >
              <Input
                maxLength={12}
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault(); // block non-numeric input
                  }
                }}
                onPaste={(event) => {
                  event.preventDefault(); // block copy-paste
                }}
                placeholder="Enter 12-digit Aadhaar number"
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="licence_number"
              label={t("licence_number")}
              rules={[
                {
                  message: "Driving License Number is required",
                },
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.resolve();
                    }

                    // Remove spaces and hyphens
                    const cleanValue = value.replace(/[\s-]/g, "");

                    // Indian Driving License Format
                    // Example: MH1220110012345
                    const regex = /^[A-Z]{2}\d{2}\d{4}\d{7}$/;

                    if (regex.test(cleanValue)) {
                      return Promise.resolve();
                    }

                    return Promise.reject(
                      new Error(
                        "Driving License should follow format like MH1220110012345 or MH12 20110012345",
                      ),
                    );
                  },
                },
              ]}
            >
              <Input placeholder="Enter Driving License Number" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={18}>
          <Col span={6}>
            {props.role == "4" && (
              <Form.Item
                name="action_taken_police_station"
                label={t("action_taken_police_station")}
                rules={[{ required: true, message: "Please choose " }]}
              >
                <Select
                  optionFilterProp="children"
                  placeholder={t("action_taken_police_station")}
                  onChange={(e) => setSelectDistricts(e)}
                  value={selectDistricts}
                >
                  {districts &&
                    districts.length > 0 &&
                    districts.map((res) => (
                      <Option key={res.id} value={res.DistrictName}>
                        {res.DistrictName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            )}
            {props.role == "2" && (
              <Form.Item
                name="action_taken_police_station"
                label={t("action_taken_police_station")}
                rules={[{ required: true }]}
              >
                <Input
                  placeholder={t("action_taken_police_station")}
                  disabled
                />
              </Form.Item>
            )}
          </Col>
          <Col span={6}>
            <Form.Item
              name="notice_date"
              label={t("notice_date")}
              rules={[{ required: true, message: "Please choose Notice Date" }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                onChange={onYearChange}
                defaultValue={startDate}
                disabledDate={disableFutureDates}
                inputReadOnly
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={18}>
          <Col span={6}>
            <Form.Item
              name="aaropi_address"
              label={t("accused_address")}
              rules={[
                {
                  message: "Please enter address",
                },
              ]}
            >
              <Input
                // onPaste={(event) => {
                //   event.preventDefault();
                // }}
                placeholder="Please enter user mobile.no"
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="aaropi_pincode"
              label={t("pincode")}
              rules={[
                {
                  pattern: /^[0-9]{6}$/,
                  message: "Pincode must be exactly 6 digits",
                },
              ]}
            >
              <Input
                maxLength={6}
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault(); // block non-numeric input
                  }
                }}
                onPaste={(event) => {
                  event.preventDefault(); // block copy-paste
                }}
                placeholder="Enter your 6-digit pincode"
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ marginBottom: "30px" }}>
            <Form.Item name="aaropi_photo" label={t("upload_profile")}>
              <Upload
                accept=".jpg,.jpeg,.png"
                customRequest={uploadImage}
                fileList={imageFileList}
                beforeUpload={beforeUploadAccusedPhoto}
                onRemove={handleRemoveImage}
                maxCount={1}
              >
                <Button icon={<UploadOutlined />}>
                  {t("add_accused_photo")}
                </Button>
              </Upload>
              <AccusedImageCropModal
                visible={cropModalVisible}
                imageSrc={cropImageSrc}
                fileName={cropOriginalFile?.name}
                mimeType={cropOriginalFile?.type}
                onCancel={cancelCrop}
                onApply={finishCrop}
                onUseOriginal={() => finishCrop(cropOriginalFile)}
              />
              <span style={{ color: "red", fontSize: "12px" }}>
                (Max. 2MB only)
              </span>
            </Form.Item>
          </Col>
          <Col span={12} style={{ marginBottom: "30px" }}>
            <Form.Item name="document" label={t("upload_pdf_only")}>
              <Upload
                accept="application/pdf"
                customRequest={uploadPdf}
                fileList={pdfFileList}
                beforeUpload={beforeUploadPdf}
                onRemove={handleRemovePdf}
                maxCount={1}
              >
                <Button icon={<UploadOutlined />}>
                  {t("upload_pdf_button")}
                </Button>
              </Upload>
              <span style={{ color: "red", fontSize: "12px" }}>
                (Max. 2MB only)
              </span>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
});
